class QuickviewTrigger extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.button = this.closest("button");

    if (!this.button) return;

    this.button.addEventListener("mouseenter", () => {
      this._getData();
    });

    this.button.addEventListener("click", () => {
      console.log(`Open quickshop`, this.url);
      this.dispatchEvent(
        new CustomEvent("markup-modal:open", {
          bubbles: true,
          detail: { target: "quickview-modal", html: this._getData() },
        }),
      );
    });
  }

  disconnectedCallback() {}

  _getData() {
    if (this._data) return Promise.resolve(this._parseData(this._data));
    if (this.loadingData) return this.loadingData;

    const url = new URL(`${window.location.origin}${this.url}`);
    url.searchParams.set("section_id", "quickview");

    this.loadingData = fetch(url)
      .then((res) => res.text())
      .then((data) => {
        this._data = data;

        return this._parseData(data);
      });

    return this.loadingData;
  }

  _parseData(data) {
    const section = new DOMParser().parseFromString(data, "text/html");
    const targetEl = document
      .createRange()
      .createContextualFragment(section.querySelector("body").innerHTML);

    return targetEl;
  }

  get url() {
    return this.getAttribute("url");
  }
}

if (!customElements.get("quickview-trigger")) {
  customElements.define("quickview-trigger", QuickviewTrigger);
}
